import { useEffect } from "react";

const SITE = "https://levelleven.nl";

function setTag(selector, create, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

/** Zet title, meta description, canonical en og-tags per pagina. */
export default function usePageMeta({ title, description }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      setTag('meta[property="og:title"]', () => { const m = document.createElement("meta"); m.setAttribute("property", "og:title"); return m; }, "content", title);
    }
    if (description) {
      setTag('meta[name="description"]', () => { const m = document.createElement("meta"); m.setAttribute("name", "description"); return m; }, "content", description);
      setTag('meta[property="og:description"]', () => { const m = document.createElement("meta"); m.setAttribute("property", "og:description"); return m; }, "content", description);
    }
    const path = window.location.pathname.replace(/\/+$/, "") || "/";
    setTag('link[rel="canonical"]', () => { const l = document.createElement("link"); l.setAttribute("rel", "canonical"); return l; }, "href", `${SITE}${path === "/" ? "/" : path}`);
  }, [title, description]);
}
